// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2KXn0","left":"InfoRow_left__3Y7cC"};